import { DataBarHorizontal24Regular, Dismiss24Filled } from '@fluentui/react-icons'
import { HideOnScrollDown } from './HideOnScrollDown'

interface Props {
  open?: boolean
  onChange: (open: boolean) => void
}

export default function NavbarMenu({ open, onChange }: Props) {
  return (
    <HideOnScrollDown className='fixed top-6 right-6 z-50'>
      <div
        className='group md:hidden bg-white text-black bg-opacity-30 backdrop-blur p-2 pl-2 rounded-lg'
        onClick={() => onChange(!open)}
      >
        <DataBarHorizontal24Regular
          className={`left-10 right-0 w-8 h-8 ${open ? 'opacity-0 [transform:rotate(60deg)]' : 'opacity-100 [transform:rotate(0deg)]'} transition-all scale-x-[-1] scale-y-[-1]`}
        />
        <Dismiss24Filled
          className={`absolute left-2 right-0 w-8 h-8 ${open ? 'opacity-100 [transform:rotate(0deg)]' : 'opacity-0 [transform:rotate(-60deg)]'} transition-all`}
        />
      </div>
    </HideOnScrollDown>
  )
}
